import type {PermissionType} from '@hconnect/apiclient'
import {usePermissionsParsedQuery} from '@hproduce/permissions'

export function useHasAnyOfEditPermissions(permissionsToCheck: PermissionType[]): PermissionType[] {
  const {data: permissions} = usePermissionsParsedQuery(permissionsToCheck)

  if (!permissions) {
    return []
  }

  return permissions
    .filter((p) => permissionsToCheck.includes(p.permissionType))
    .map((p) => p.permissionType)
}
